export class FormDataBuilder {
  constructor (options = {}) {
    this.formData = new FormData()
    this.options = {
      arrayStrategy: 'indexed', // 'indexed' | 'bracket' | 'repeat'
      ...options
    }
  }

  append (fieldKey, fieldValue, callbacksByKey = {}) {
    if (callbacksByKey?.[fieldKey] && typeof callbacksByKey[fieldKey] === 'function') {
      callbacksByKey[fieldKey]({
        formData: this.formData,
        value: fieldValue
      })
    }
    else if (fieldValue instanceof File) {
      this.formData.append(fieldKey, fieldValue)
    }
    else if (Array.isArray(fieldValue)) {
      if (fieldValue.length === 0) {
        this.formData.append(`${fieldKey}[]`, '')
      }
      else {
        fieldValue.forEach((value, index) => {
          const key = this.options.arrayStrategy === 'indexed'
            ? `${fieldKey}[${index}]`
            : `${fieldKey}[]`
          this.append(key, value)
        })
      }
    }
    else if (typeof fieldValue === 'object' && fieldValue !== null) {
      Object.keys(fieldValue).forEach(key => {
        this.append(`${fieldKey}[${key}]`, fieldValue[key])
      })
    }
    else {
      this.formData.append(fieldKey, fieldValue ?? '')
    }
  }

  build (data, callBacksByKey = {}) {
    Object.keys(data).forEach(key => {
      this.append(key, data[key], callBacksByKey)
    })
    return this.formData
  }
}
